import React from 'react'
import s from './Throbber.less'
import img from './throbber.png'

export default function Throbber() {
  return (
    <div className={s.Throbber}>
      <img src={img} />
    </div>
  )
}
